import { NewsletterPrompt } from '@/components/marketing/NewsletterPrompt';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { InsufficientCreditsModal } from '@/components/kanban/InsufficientCreditsModal';
import { FreeTrialBanner } from './FreeTrialBanner';
import { ImpersonationBanner } from './ImpersonationBanner';

export function AppLayout() {
  return (
    <div className="min-h-dvh app-gradient text-gray-900 dark:text-gray-100 flex flex-col">
      <ImpersonationBanner />
      <FreeTrialBanner />
      <AppHeader />
      <main className="w-full max-w-[1920px] flex-grow overflow-visible bg-transparent px-4 py-5 sm:px-6 sm:py-6 mx-auto">
        <Outlet />
      </main>
      <InsufficientCreditsModal />
      <NewsletterPrompt />
    </div>
  );
}
